import React from 'react';
import {Input} from 'antd';

import './index.styl';

class Inputc extends Input{
    render() {
        return (
            <Input {...this.props} />
        )
    }
}

export default Inputc;
